import { TcClickTypes } from 'src/configuration/tagcommander'

import { Recipe } from '../../types/fam-graphql'
import { ActionButtonProps } from '../../components/ActionButton'
import { RecipeCardListProps } from '../../components/RecipeCardList'
import { recipeCardTransformer } from '../Recipe/RecipeCard'
import tcClick from '../tcClick/tcClick'

export const recipesCardListTransformer = (params: {
  t: any
  recipes: Recipe[]
  loadMoreFunction?: () => void
  loadPreviousFunction?: () => void
  handleSwitchCourse?: (id: string) => void
  isFromRecipeList?: boolean
  tcVars?: {
    chapter2: string
    chapter3: string
  }
  isFromSwitchCourse?: boolean
}): RecipeCardListProps => {
  const {
    t,
    recipes,
    loadMoreFunction,
    handleSwitchCourse,
    isFromRecipeList,
    tcVars,
    isFromSwitchCourse,
    loadPreviousFunction,
  } = params
  return {
    items: recipes?.map((r) =>
      recipeCardTransformer(
        t,
        r,
        undefined,
        undefined,
        handleSwitchCourse,
        undefined,
        undefined,
        undefined,
        isFromRecipeList,
        tcVars,
        isFromSwitchCourse
      )
    ),
    noResults: t('recipes_list_no_results'),
    loadPreviousButtonProps:
      loadPreviousFunction &&
      ({
        text: t('recipes_list_load_previous'),
        variantType: 'button',
        variantColorScheme: 'black',
        actionProps: {
          onClick: () => {
            tcClick({
              click_name: `${t('recipes_list_load_previous')}_fam`,
              click_type: TcClickTypes.navigation,
              chapter1: 'navigation fam',
              chapter2: tcVars?.chapter2,
              chapter3: tcVars?.chapter3,
            })
            loadPreviousFunction()
          },
        },
      } as ActionButtonProps),
    loadMoreButtonProps:
      loadMoreFunction &&
      ({
        text: t('recipes_list_load_more'),
        variantType: 'button',
        variantColorScheme: 'black',
        actionProps: {
          onClick: () => {
            tcClick({
              click_name: `${t('recipes_list_load_more')}_fam`,
              click_type: TcClickTypes.navigation,
              chapter1: 'navigation fam',
              chapter2: tcVars?.chapter2,
              chapter3: tcVars?.chapter3,
            })
            loadMoreFunction()
          },
        },
      } as ActionButtonProps),
  }
}

export const childrenRecipesCardListTransformer = (params: {
  t: any
  recipes: Recipe[]
  parentRecipe: string
}): RecipeCardListProps => {
  const { t, recipes, parentRecipe } = params
  return {
    items: recipes?.map((r) =>
      recipeCardTransformer(
        t,
        r,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        true,
        undefined,
        undefined,
        undefined,
        parentRecipe
      )
    ),
    noResults: t('recipes_list_no_results'),
  }
}
